import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, union_type, record_type, string_type, int32_type, option_type, array_type, class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Dashboard_CohCompanyEntry_$reflection, Dashboard_CohSeverityEntry_$reflection, Dashboard_TypeSummaryEntry_$reflection, Dashboard_CohStatusSummary_$reflection, CustomerGroup_$reflection } from "../Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { fromDateTime } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { addMonths, now as now_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { removeQuery, setQuery, getUrlAsPath } from "../Utils.js";
import { some, unwrap, map, bind, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Tickets_Severity_FromId_Z524259A4, Tickets_Severity__get_ColorCode, Tickets_TicketType_FromId_Z524259A4, Tickets_TicketStatus, Tickets_TicketStatus__get_Id, DateOnly_iso, DateOnly_tryParse } from "../Shared/Shared.js";
import { sortByDescending, map as map_1, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { defaultOf, comparePrimitives, createObj, uncurry2, int32ToString, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { generateQueryString } from "../Shared/Urls.js";
import { toList, empty, singleton, append, delay, toArray } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty as empty_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Tickets_severity, Tickets_toLocalizedType, Tickets_toLocalizedStatus } from "../Locale.js";
import { Components_Chip_51BC9844, ComponentsModule_Chip_Level } from "../Components/Chip.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import AccessTime from "@mui/icons-material/AccessTime";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Cached from "@mui/icons-material/Cached";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Autocomplete, TextField, Table, TableBody, TableRow, TableCell, Skeleton, Divider, Typography } from "@mui/material";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import Circle from "@mui/icons-material/Circle";
import { ctx as ctx_1 } from "../Context.js";
import { CustomerGroup_fetchGroups } from "../Promises.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Int32.js";
import { SnackError } from "../ViewHelpers.js";

class Model extends Record {
    constructor(PeriodStart, PeriodEnd, CustomerGroups, SelectedGroup, SelectedGroupId, StatusSummary, TypeSummary, SeveritySpread, CompaniesSpread, ErrorMsg) {
        super();
        this.PeriodStart = PeriodStart;
        this.PeriodEnd = PeriodEnd;
        this.CustomerGroups = CustomerGroups;
        this.SelectedGroup = SelectedGroup;
        this.SelectedGroupId = SelectedGroupId;
        this.StatusSummary = StatusSummary;
        this.TypeSummary = TypeSummary;
        this.SeveritySpread = SeveritySpread;
        this.CompaniesSpread = CompaniesSpread;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Dashboards.COH.Model", [], Model, () => [["PeriodStart", class_type("System.DateOnly")], ["PeriodEnd", class_type("System.DateOnly")], ["CustomerGroups", array_type(CustomerGroup_$reflection())], ["SelectedGroup", option_type(CustomerGroup_$reflection())], ["SelectedGroupId", option_type(int32_type)], ["StatusSummary", option_type(Dashboard_CohStatusSummary_$reflection())], ["TypeSummary", option_type(array_type(Dashboard_TypeSummaryEntry_$reflection()))], ["SeveritySpread", option_type(array_type(Dashboard_CohSeverityEntry_$reflection()))], ["CompaniesSpread", option_type(array_type(Dashboard_CohCompanyEntry_$reflection()))], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StatusSummaryResponse", "TypeSummaryResponse", "SeveritySpreadResponse", "CompaniesSpreadResponse", "GroupsResponse", "SetGroups", "UpdatePeriodStart", "UpdatePeriodEnd", "SelectGroup", "SelectGroupId", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Dashboards.COH.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_CohStatusSummary_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Dashboard_CohStatusSummary_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Dashboard_TypeSummaryEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Dashboard_TypeSummaryEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Dashboard_CohSeverityEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Dashboard_CohSeverityEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Dashboard_CohCompanyEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Dashboard_CohCompanyEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(CustomerGroup_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(CustomerGroup_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", array_type(CustomerGroup_$reflection())]], [["Item", class_type("System.DateOnly")]], [["Item", class_type("System.DateOnly")]], [["Item", option_type(CustomerGroup_$reflection())]], [["Item", option_type(int32_type)]], []]);
}

function init() {
    const now = fromDateTime(now_1());
    const url = getUrlAsPath();
    return new Model(defaultArg(bind(DateOnly_tryParse, url.searchParams.get("from")), addMonths(now, -1)), defaultArg(bind(DateOnly_tryParse, url.searchParams.get("until")), now), [], undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 1) {
                return model;
            }
            else {
                return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, res_1.fields[0], model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
            }
        }
        case 2: {
            const res_2 = msg.fields[0];
            if (res_2.tag === 1) {
                return model;
            }
            else {
                return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, res_2.fields[0], model.CompaniesSpread, model.ErrorMsg);
            }
        }
        case 3: {
            const res_3 = msg.fields[0];
            if (res_3.tag === 1) {
                return model;
            }
            else {
                return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, model.SeveritySpread, res_3.fields[0], model.ErrorMsg);
            }
        }
        case 4: {
            const res_4 = msg.fields[0];
            if (res_4.tag === 1) {
                return model;
            }
            else {
                return new Model(model.PeriodStart, model.PeriodEnd, res_4.fields[0], model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
            }
        }
        case 6:
            return new Model(msg.fields[0], model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
        case 7:
            return new Model(model.PeriodStart, msg.fields[0], model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
        case 5:
            return new Model(model.PeriodStart, model.PeriodEnd, msg.fields[0], model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
        case 8: {
            const groupOpt = msg.fields[0];
            return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, groupOpt, map((_arg) => _arg.Id, groupOpt), model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
        }
        case 9: {
            const id = msg.fields[0];
            return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, tryFind((group) => equals(group.Id, id), model.CustomerGroups), id, model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
        }
        case 10:
            return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.StatusSummary, model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return model;
            }
            else {
                return new Model(model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, res.fields[0], model.TypeSummary, model.SeveritySpread, model.CompaniesSpread, model.ErrorMsg);
            }
        }
    }
}

export function toRequestPath(periodStart, periodEnd, groupOpt, basePath) {
    const ps = DateOnly_iso(periodStart);
    const pe = DateOnly_iso(periodEnd);
    return basePath + generateQueryString(toArray(delay(() => append(singleton(["from", ps]), delay(() => append(singleton(["until", pe]), delay(() => {
        const matchValue = groupOpt;
        if (matchValue != null) {
            return singleton(["group", int32ToString(matchValue.Id)]);
        }
        else {
            return empty();
        }
    })))))));
}

function fetchStatusSummary(periodStart, periodEnd, group) {
    let properties_2;
    const url = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/coh/status-summary");
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(Dashboard_CohStatusSummary_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_CohStatusSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchTypeSummary(periodStart, periodEnd, group, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/coh/type-spread");
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_TypeSummaryEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_TypeSummaryEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(1, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function fetchSeveritySpread(periodStart, periodEnd, group, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const url = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/coh/severity-spread");
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_CohSeverityEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_CohSeverityEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(2, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function fetchCompanySpread(periodStart, periodEnd, group, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const url = toRequestPath(periodStart, periodEnd, group, "/api/dashboard/coh/company-spread");
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_CohCompanyEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_CohCompanyEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(3, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function drawStatusSummary(locale, x) {
    let elems_2, elems_1;
    const statusEntry = (status, num) => {
        let elems, $keyZ226FACDE;
        const text = Tickets_toLocalizedStatus(locale, Tickets_TicketStatus__get_Id(status));
        const patternInput = (status.tag === 2) ? [new ComponentsModule_Chip_Level(0, []), (props_3) => {
            const props_5 = createObj(props_3);
            return react.createElement(AccessTime, props_5);
        }] : ((status.tag === 3) ? [new ComponentsModule_Chip_Level(3, []), (props_6) => {
            const props_8 = createObj(props_6);
            return react.createElement(InfoOutlined, props_8);
        }] : ((status.tag === 4) ? [new ComponentsModule_Chip_Level(1, []), (props_9) => {
            const props_11 = createObj(props_9);
            return react.createElement(CheckCircle, props_11);
        }] : ((status.tag === 1) ? [new ComponentsModule_Chip_Level(0, []), (props_12) => {
            const props_14 = createObj(props_12);
            return react.createElement(Cached, props_14);
        }] : [new ComponentsModule_Chip_Level(5, []), (props) => {
            const props_2 = createObj(props);
            return react.createElement(MoreHoriz, props_2);
        }])));
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: ((5 + "px ") + 10) + "px",
            borderRadius: 5,
        }], (elems = [($keyZ226FACDE = (`ticket-status-chip-${text}`), createElement(Components_Chip_51BC9844, {
            key: $keyZ226FACDE,
            $key: $keyZ226FACDE,
            primary: text,
            enabled: true,
            startIcon: patternInput[1],
            colorLevel: patternInput[0],
        })), createElement("span", {
            style: {
                marginLeft: 5,
                fontWeight: "bold",
            },
            children: num,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
        minWidth: 276 + "px",
        padding: 20,
        border: (((1 + "px ") + "solid") + " ") + "#dedede",
        borderRadius: 15,
    }], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", "Status"]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_1 = toList(delay(() => {
        if (x != null) {
            const y = x;
            return append(singleton(statusEntry(new Tickets_TicketStatus(0, []), y.NumOpen)), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => append(singleton(statusEntry(new Tickets_TicketStatus(2, []), y.NumInProgress)), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => append(singleton(statusEntry(new Tickets_TicketStatus(3, []), y.NumHold)), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => append(singleton(statusEntry(new Tickets_TicketStatus(4, []), y.NumClosed)), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(statusEntry(new Tickets_TicketStatus(1, []), y.NumReopened))))))))))))))))));
        }
        else {
            return append(singleton(MuiHelpers_createElement(Skeleton, [])), delay(() => append(singleton(MuiHelpers_createElement(Skeleton, [])), delay(() => append(singleton(MuiHelpers_createElement(Skeleton, [])), delay(() => singleton(MuiHelpers_createElement(Skeleton, []))))))));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function drawTypeSummary(locale, entriesOpt) {
    let elems_5, elems_4;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px ",
        border: (((1 + "px ") + "solid") + " ") + "#dedede",
        borderRadius: 15,
        padding: 20,
    }], (elems_5 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", locale.t("Dashboard.CriticalOperationalHalts.CountByTypeSpread")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 15 + "px ",
    }], (elems_4 = toList(delay(() => {
        let properties_6, value_24, properties_5, elements_1, properties_4, elements;
        if (entriesOpt != null) {
            const entries = entriesOpt;
            const toPieColorCode = (ticketTypeId) => {
                const _arg = Tickets_TicketType_FromId_Z524259A4(ticketTypeId);
                switch (_arg.tag) {
                    case 1:
                        return "#59227a";
                    case 2:
                        return "#ffa500";
                    case 3:
                        return "#962318";
                    case 4:
                        return "#1a8a38";
                    case 5:
                        return "#75abe0";
                    case 6:
                        return "#b664e8";
                    case 7:
                        return "#ffc761";
                    case 8:
                        return "#de584b";
                    default:
                        return "rgba(91, 127, 149, 1)";
                }
            };
            const pieData = map_1((z_1) => ({
                Name: Tickets_toLocalizedType(locale, Tickets_TicketType_FromId_Z524259A4(z_1.TypeId)),
                Num: z_1.Num,
                TypeId: z_1.TypeId,
            }), sortByDescending((z) => z.Num, entries, {
                Compare: comparePrimitives,
            }));
            return (entries.length === 0) ? singleton(createElement("span", {
                children: [locale.t("TicketList.NoTickets")],
            })) : append(singleton((properties_6 = ofArray([(value_24 = (100 + "%"), (equals(value_24, 100 + "%") ? true : equals(value_24, 100 + "%")) ? ["width", 99 + "%"] : ["width", value_24]), ["minWidth", 275 + "px"], ["minHeight", 300 + "px"], ["children", (properties_5 = ofArray([["margin", {
                top: defaultArg(10, 0),
                right: defaultArg(undefined, 0),
                left: defaultArg(undefined, 0),
                bottom: defaultArg(30, 0),
            }], (elements_1 = singleton_1((properties_4 = ofArray([["data", pieData], ["dataKey", "Num"], ["label", true], ["fill", "#59227a"], ["nameKey", "Name"], ["innerRadius", 50], (elements = map_1((z_3) => {
                const properties_3 = ofArray([["key", Tickets_toLocalizedType(locale, Tickets_TicketType_FromId_Z524259A4(z_3.TypeId))], ["fill", toPieColorCode(z_3.TypeId)]]);
                return reactApi_1.createElement(Cell, createObj(properties_3));
            }, sortByDescending((z_2) => z_2.Num, pieData, {
                Compare: comparePrimitives,
            })), ["children", ["children", reactApi.Children.toArray(Array.from(elements))]])]), reactApi_1.createElement(Pie, createObj(properties_4)))), ["children", reactApi.Children.toArray(Array.from(elements_1))])]), reactApi_1.createElement(PieChart, createObj(properties_5)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_6)))), delay(() => {
                let elems_3;
                return singleton(createElement("div", createObj(singleton_1((elems_3 = map_1((t_1) => {
                    let elems_2, props_4;
                    const ticketType_2 = Tickets_TicketType_FromId_Z524259A4(t_1.TypeId);
                    return createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px",
                    }], (elems_2 = [(props_4 = {
                        style: {
                            color: toPieColorCode(t_1.TypeId),
                        },
                    }, react.createElement(Circle, props_4)), MuiHelpers_createElement(Typography, [["noWrap", true], ["children", Tickets_toLocalizedType(locale, ticketType_2)]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                }, sortByDescending((t) => t.Num, entries, {
                    Compare: comparePrimitives,
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])))));
            }));
        }
        else {
            return singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                minWidth: 200,
                minHeight: 200,
            }]]));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function drawSeveritySpread(locale, entriesOpt) {
    let elems_5, elems_4;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px ",
        border: (((1 + "px ") + "solid") + " ") + "#dedede",
        borderRadius: 15,
        padding: 20,
    }], (elems_5 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", locale.t("Dashboard.CriticalOperationalHalts.CountBySeveritySpread")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 15 + "px",
    }], (elems_4 = toList(delay(() => {
        let properties_6, properties_5, elements_1, properties_4, elements;
        if (entriesOpt != null) {
            const entries = entriesOpt;
            const toPieColorCode = (severityId) => Tickets_Severity__get_ColorCode(Tickets_Severity_FromId_Z524259A4(severityId));
            const pieData = map_1((z_1) => ({
                Name: Tickets_severity(locale, Tickets_Severity_FromId_Z524259A4(z_1.SeverityId)),
                Num: z_1.Num,
                SeverityId: z_1.SeverityId,
            }), sortByDescending((z) => z.Num, entries, {
                Compare: comparePrimitives,
            }));
            return (entries.length === 0) ? singleton(createElement("span", {
                children: [locale.t("TicketList.NoTickets")],
            })) : append(singleton((properties_6 = ofArray([["minWidth", 275 + "px"], ["minHeight", 300 + "px"], ["children", (properties_5 = ofArray([["margin", {
                top: defaultArg(10, 0),
                right: defaultArg(undefined, 0),
                left: defaultArg(undefined, 0),
                bottom: defaultArg(30, 0),
            }], (elements_1 = singleton_1((properties_4 = ofArray([["data", pieData], ["dataKey", "Num"], ["label", true], ["fill", "#59227a"], ["nameKey", "Name"], ["innerRadius", 50], (elements = map_1((z_3) => {
                const properties_3 = ofArray([["key", Tickets_severity(locale, Tickets_Severity_FromId_Z524259A4(z_3.SeverityId))], ["fill", toPieColorCode(z_3.SeverityId)]]);
                return reactApi_1.createElement(Cell, createObj(properties_3));
            }, sortByDescending((z_2) => z_2.Num, pieData, {
                Compare: comparePrimitives,
            })), ["children", ["children", reactApi.Children.toArray(Array.from(elements))]])]), reactApi_1.createElement(Pie, createObj(properties_4)))), ["children", reactApi.Children.toArray(Array.from(elements_1))])]), reactApi_1.createElement(PieChart, createObj(properties_5)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_6)))), delay(() => {
                let elems_3;
                return singleton(createElement("div", createObj(singleton_1((elems_3 = map_1((t_1) => {
                    let elems_2, props_4;
                    const severity_2 = Tickets_Severity_FromId_Z524259A4(t_1.SeverityId);
                    return createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px",
                    }], (elems_2 = [(props_4 = {
                        style: {
                            color: toPieColorCode(t_1.SeverityId),
                        },
                    }, react.createElement(Circle, props_4)), MuiHelpers_createElement(Typography, [["noWrap", true], ["children", Tickets_severity(locale, severity_2)]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                }, sortByDescending((t) => t.Num, entries, {
                    Compare: comparePrimitives,
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])))));
            }));
        }
        else {
            return singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                minWidth: 200,
                minHeight: 200,
            }]]));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function drawCompanySpread(locale, x) {
    let elems_3;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px ",
        padding: 20,
        border: (((1 + "px ") + "solid") + " ") + "#dedede",
        borderRadius: 15,
    }], (elems_3 = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", locale.t("Dashboard.CriticalOperationalHalts.CountByCompany")]])), delay(() => {
        let children_2, children_1;
        const matchValue = x;
        return (matchValue != null) ? singleton((children_2 = singleton_1((children_1 = map_1((z_1) => {
            const children = ofArray([MuiHelpers_createElement(TableCell, [["variant", "body"], ["size", "small"], ["children", z_1.Company]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["size", "small"], ["children", z_1.Num]])]);
            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
        }, sortByDescending((z) => z.Num, matchValue, {
            Compare: comparePrimitives,
        })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_1))]]))), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_2))]]))) : singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
            minWidth: 200,
            minHeight: 200,
        }]]));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function View() {
    let elems_2, elems, elems_1;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(true);
    reactApi.useEffect(() => {
        console.debug("[AdminDashboards] Mounting COH dashboard");
        const pr = CustomerGroup_fetchGroups(false);
        pr.then((res) => {
            if (res.tag === 0) {
                const url = getUrlAsPath();
                const selectedGroup = map((value) => parse(value, 511, false, 32), url.searchParams.get("group"));
                dispatch(new Message(5, [res.fields[0]]));
                dispatch(new Message(9, [selectedGroup]));
            }
            else {
                console.error(some(""));
            }
            patternInput_1[1](false);
        });
    }, []);
    const dependencies_2 = [model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup];
    reactApi.useEffect(() => {
        const pr_1 = fetchStatusSummary(model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup);
        pr_1.then((arg_2) => {
            dispatch(new Message(0, [arg_2]));
        });
    }, dependencies_2);
    const dependencies_4 = [model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup];
    reactApi.useEffect(() => {
        fetchTypeSummary(model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup, dispatch);
    }, dependencies_4);
    const dependencies_6 = [model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup];
    reactApi.useEffect(() => {
        fetchSeveritySpread(model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup, dispatch);
    }, dependencies_6);
    const dependencies_8 = [model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup];
    reactApi.useEffect(() => {
        fetchCompanySpread(model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup, dispatch);
    }, dependencies_8);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 20 + "px",
    }], (elems_2 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(10, []));
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 15 + "px ",
    }], (elems = [MuiHelpers_createElement(TextField, [["type", "date"], ["label", ctx.Locale.t("FromDate")], ["sx", {
        minWidth: 250 + "px",
    }], ["value", DateOnly_iso(model_1.PeriodStart)], ["onChange", (e) => {
        const str = e.target.value;
        const matchValue = DateOnly_tryParse(str);
        if (matchValue != null) {
            const date = matchValue;
            const periodStartStr = DateOnly_iso(date);
            dispatch(new Message(6, [date]));
            setQuery("from", periodStartStr);
        }
        else {
            console.error(some("[AdminDashboard] Error parsing period start date"), str);
        }
    }]]), MuiHelpers_createElement(TextField, [["type", "date"], ["label", ctx.Locale.t("ToDate")], ["sx", {
        minWidth: 250 + "px",
    }], ["value", DateOnly_iso(model_1.PeriodEnd)], ["onChange", (e_1) => {
        const str_1 = e_1.target.value;
        const matchValue_1 = DateOnly_tryParse(str_1);
        if (matchValue_1 != null) {
            const date_1 = matchValue_1;
            const periodEndStr = DateOnly_iso(date_1);
            dispatch(new Message(7, [date_1]));
            setQuery("until", periodEndStr);
        }
        else {
            console.error(some("[AdminDashboard] Error parsing period end date"), str_1);
        }
    }]]), MuiHelpers_createElement(Autocomplete, [["loading", patternInput_1[0]], ["getOptionLabel", (group) => group.Name], ["value", defaultArg(model_1.SelectedGroup, defaultOf())], ["options", Array.from(model_1.CustomerGroups)], ["onChange", (delegateArg, delegateArg_1, delegateArg_2) => {
        const newGroup = delegateArg_1;
        dispatch(new Message(8, [newGroup]));
        if (newGroup != null) {
            setQuery("group", int32ToString(newGroup.Id));
        }
        else {
            removeQuery("group");
        }
    }], ["renderInput", (props_2) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props_2), delay(() => append(singleton(["sx", {
        minWidth: 250 + "px",
    }]), delay(() => singleton(["label", ctx.Locale.t("Group.CustomerGroup")]))))))))]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 30 + "px ",
    }], (elems_1 = [drawCompanySpread(ctx.Locale, model_1.CompaniesSpread), drawStatusSummary(ctx.Locale, model_1.StatusSummary), drawTypeSummary(ctx.Locale, model_1.TypeSummary), drawSeveritySpread(ctx.Locale, model_1.SeveritySpread)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

